
export default {
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    classObject() {
      return {
        'hidden sm:block': this.blok.hide_breakpoint === 'xs',
        'hidden md:block': this.blok.hide_breakpoint === 'sm',
        'hidden lg:block': this.blok.hide_breakpoint === 'md',
        'hidden xl:block': this.blok.hide_breakpoint === 'lg',
        hidden: this.blok.hide_breakpoint === 'xl',
      }
    },
  },
}
